const routerArr = [{
        path: 'projectManagement',
        name: 'projectManagement',
        component: (resolve) => require(["@/container/pages/communityManagement/base"], resolve),
        meta: { 
            show: '1110', 
            title: '社区管理', 
            source: '11b6',
            keepAlive: true, //此组件需要被缓存
            keepPath:"/home/projectManagement" //需要在这个页面还要保持缓存的页面。可以根据需要改成数组
        },
    },
    {
        path: 'allocationFunction',
        name: 'allocationFunction',
        component: (resolve) => require(["page/communityManagement/base/allocationFunction"], resolve),
        meta: { show: '1110', title: '分配功能', source: '11b6',keepPath:"/home/projectManagement" }
    },
    {
        path: 'projectManagementAdd',
        name: 'projectManagementAdd',
        component: (resolve) => require(["page/communityManagement/base/addPage"], resolve),
        meta: { show: '1110', title: '新增', source: '11b6',keepPath:"/home/projectManagement" }
    },
    {
        path: 'projectManagementDetail',
        name: 'projectManagementDetail',
        component: (resolve) => require(["page/communityManagement/base/detail"], resolve),
        meta: { show: '1110', title: '详情', source: '11b6',keepPath:"/home/projectManagement" }
    },
    {
        path: 'projectManagement-house',
        name: 'projectManagement-house',
        component: (resolve) => require(["page/communityManagement/base/houses"], resolve),
        meta: { show: '1110', title: '楼盘管理', source: '11b6',keepPath:"/home/projectManagement" }
    },
    {
        path: 'contact-company',
        name: 'contact-company',
        component: (resolve) => require(["page/communityManagement/base/contactCompany"], resolve),
        meta: { show: '1110', title: '关联企业', source: '11b6',keepPath:"/home/projectManagement" }
    },
    {
        path: 'projectManagementImport',
        name: 'projectManagementImport',
        component: (resolve) => require(["page/communityManagement/base/import"], resolve),
        meta: { show: '1110', title: '社区导入', source: '11b6',keepPath:"/home/projectManagement" }
    },
];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/communityManagement/_res.js